import Direction from '@shared/types/enums/direction';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import Colors from '@shared/assets/style/default/color';

const UpgradablePlanText = styled.span<{
  color?: string;
  direction?: Direction;
  fontBold?: boolean;
  fontSize?: number;
}>`
  color: ${(props) => (props.color ? props.color : Colors['light'])};
  font-family: ${(props) => Fonts[props.fontBold ? 'bold' : 'light']};
  font-size: ${(props) => (props.fontSize || 30) * Screen.widthRatio}px;
  line-height: ${(props) =>
    props.direction === Direction.VERTICAL
      ? `${48 * Screen.widthRatio}px`
      : ''};
  margin-left: ${(props) =>
    (props.direction === Direction.HORIZONTAL ? 8 : 0) * Screen.widthRatio}px;
  text-shadow: ${2 * Screen.widthRatio}px ${2 * Screen.widthRatio}px
    ${5 * Screen.widthRatio}px black;
`;

export default UpgradablePlanText;
